import { Injectable } from '@angular/core';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';

import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as applicationActions from '../../stateManagement/actions/containers/application';
import * as _ from 'lodash';
import * as commonTypes from '../../shared/types';
import { PortalInfoService } from '../services/portalInfo.service';

@Injectable()
export class PortalInformationEffects {
  constructor(
    private actions$: Actions,
    private store: Store<IApplicationState>,
    private portalInfoService: PortalInfoService
  ) {}

  @Effect() 
  getPortalInfor$: Observable<Action> = this.actions$
    .ofType(applicationActions.ActionTypes.LOAD_PORTAL_INFO)
    .startWith(new applicationActions.LoadPortalInformationAction({}))
    .switchMap(() => 
        this.portalInfoService.getPortalInfo()
            .map((data: commonTypes.IPortalInfo) => new applicationActions.LoadPortalInformationSuccessAction(data))
            .catch(error => {
                this.portalInfoService.handleError(error.status,
                    'Portal Information Retrieve Failure', this.extractErrorMessage(error.json()),
                    new applicationActions.LoadPortalInformationAction({}));
                return Observable.of(new applicationActions.LoadPortalInformationFailureAction({ message: error.json() }));
            })
    )

    private extractErrorMessage(error): string {
    if (_.has(error, 'message')) {
      return error.message;
    }

    return JSON.stringify(error);
  }    
}



// WEBPACK FOOTER //
// ./src/app/shared/effects/portalInfo.effect.ts